/* Homepage behaviour (owner: A1): testimonials carousel (summary block v2) and the Instagram video tile. */
(function () {
  'use strict';
  var MOBILE = window.matchMedia('screen and (max-width: 767px)');

  /* ---- Summary carousel: 2 slides per view; each step moves one view (translateX -101%), 0.4s.
     Flaw preserved: on mobile only one slide fits per view but the paging still counts 2 per view (3 pages), so the last
     three testimonials cannot be reached with the arrows (observed on the live site at 390px). ---- */
  Array.prototype.forEach.call(document.querySelectorAll('.summary-block-setting-design-carousel'), function (wrap) {
    var list = wrap.querySelector('.summary-item-list');
    var items = wrap.querySelectorAll('.summary-item');
    var prev = wrap.querySelector('.summary-carousel-pager-prev');
    var next = wrap.querySelector('.summary-carousel-pager-next');
    if (!list || !prev || !next || !items.length) return;
    var perRow = parseInt(wrap.getAttribute('data-slides-per-row'), 10) || 2;
    var page = 0;
    function pages() { return Math.max(1, Math.ceil(items.length / (MOBILE.matches ? 1 : perRow))); }
    function setDisabled(el, off) { el.classList.toggle('sqs-disabled', off); el.setAttribute('aria-disabled', off ? 'true' : 'false'); }
    function render() {
      var n = pages();
      if (page > n - 1) page = n - 1;
      list.style.transform = 'translateX(' + (-101 * page) + '%)';
      setDisabled(prev, page === 0);
      setDisabled(next, page >= n - 1);
    }
    function go(d) { var n = pages(), p = Math.min(n - 1, Math.max(0, page + d)); if (p !== page) { page = p; render(); } }
    [[prev, -1], [next, 1]].forEach(function (pair) {
      pair[0].addEventListener('click', function () { go(pair[1]); });
      pair[0].addEventListener('keydown', function (e) { if (e.key === 'Enter' || e.key === ' ') { e.preventDefault(); go(pair[1]); } });
    });
    if (MOBILE.addEventListener) MOBILE.addEventListener('change', render); else if (MOBILE.addListener) MOBILE.addListener(render);
    render();
  });

  /* ---- Instagram video tile: clicking the play icon swaps the poster for the reel embed (as the original gallery does) ---- */
  Array.prototype.forEach.call(document.querySelectorAll('.sqs-video-wrapper[data-html]'), function (vw) {
    var overlay = vw.querySelector('.sqs-video-overlay');
    function play() {
      if (!overlay || !overlay.parentNode) return;
      var tpl = document.createElement('div');
      tpl.innerHTML = vw.getAttribute('data-html');
      var iframe = tpl.querySelector('iframe');
      if (!iframe) return;
      iframe.setAttribute('allowfullscreen', '');
      overlay.parentNode.removeChild(overlay);
      vw.appendChild(iframe);
    }
    var icon = vw.querySelector('.sqs-video-icon');
    if (icon) {
      icon.addEventListener('click', play);
      icon.addEventListener('keydown', function (e) { if (e.key === 'Enter' || e.key === ' ') { e.preventDefault(); play(); } });
    }
  });
})();
